/**
 * 檔案用途區塊
 * @module sso-urls.constants
 * @purpose 集中管理各第三方登入頁面的 OAuth 授權入口網址，供路由對應與登入導流使用。
 * @external https://innotech.atlassian.net/browse/IN-132134
 * @external https://innotech.atlassian.net/browse/IN-94351
 * @external https://innotech.atlassian.net/browse/IN-89368
 * @external https://innotech.atlassian.net/browse/IN-54243
 * @external https://innotech.atlassian.net/browse/IN-54205
 */
import { Page } from '@shared/enums/route.enum';

/**
 * 宣告內容用途說明與單號關聯
 * @description 以 Page 列舉鍵值對應各 SSO 平台授權 URL，作為登入流程組裝導向位址的來源常數。
 * @purpose 維持單一可維護的 SSO 端點對照表，避免各處散落硬編碼網址。
 * @external https://innotech.atlassian.net/browse/IN-54205
 */
export const ssoUrls: PartialRecord<Page, string> = {
  [Page.Apple]: 'https://appleid.apple.com/auth/authorize',
  [Page.Google]: 'https://accounts.google.com/o/oauth2/v2/auth',
  [Page.FaceBook]: 'https://www.facebook.com/v20.0/dialog/oauth',
  [Page.Zalo]: 'https://oauth.zaloapp.com/v4/permission',
  [Page.Telegram]: 'https://oauth.telegram.org/auth',
};

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:21:37.460Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section JSDoc annotations (top/middle/bottom) with specified tags, mapped declaration-level @external strictly to declarationOrigins ticket, converted all externals to full Jira browse URLs, and kept runtime code unchanged.
 */
